var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_65",
    "data-name": "Group 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.55,
    height: 47.55,
    viewBox: "0 0 47.55 47.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 61.094,
    y1: -11.08,
    x2: 61.094,
    y2: -10.186,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb92e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#dda228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#aa7c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#7c5b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#563f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#36280a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1e1605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0d0902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 1.558,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#442914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#3d230f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#2a1301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.53,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.5,
    cy: 0.5,
    r: 0.529,
    xlinkHref: "#radial-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M-2242.056,350.08a23.775,23.775,0,0,1-23.775,23.775,23.775,23.775,0,0,1-23.775-23.775,23.775,23.775,0,0,1,23.775-23.774A23.775,23.775,0,0,1-2242.056,350.08Z",
    transform: "translate(2289.606 -326.306)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M-2234.015,340.125c0,5.958-7.1,10.792-15.863,10.792s-15.863-4.834-15.863-10.792,7.1-10.792,15.863-10.792S-2234.015,334.164-2234.015,340.125Z",
    transform: "translate(2273.653 -328.33)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M-2269.887,404.527c0-6.934,7.718-12.556,17.238-12.556s17.237,5.621,17.237,12.556-7.718,12.556-17.237,12.556S-2269.887,411.461-2269.887,404.527Z",
    transform: "translate(2276.425 -370.201)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(10.532 11.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 17.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M-2232.271,421.5a.918.918,0,0,1-.707-.331c-2.029-2.428-6.588-4-11.616-4s-9.587,1.569-11.616,4a.921.921,0,0,1-1.3.117.921.921,0,0,1-.116-1.3c2.4-2.874,7.395-4.66,13.031-4.66s10.63,1.786,13.03,4.66a.919.919,0,0,1-.116,1.3A.92.92,0,0,1-2232.271,421.5Z",
    transform: "translate(2257.839 -415.328)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(1.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(16.667 8.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M-2197.9,388.888a2.377,2.377,0,0,1-2.378,2.377,2.379,2.379,0,0,1-2.379-2.377,2.381,2.381,0,0,1,2.379-2.379A2.379,2.379,0,0,1-2197.9,388.888Z",
    transform: "translate(2202.655 -386.509)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(15.596 0.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M-2204.964,369.828a.919.919,0,0,1-.7-.319.92.92,0,0,1,.095-1.3l5.849-5.053a.92.92,0,0,1,1.3.095.92.92,0,0,1-.095,1.3l-5.848,5.053A.912.912,0,0,1-2204.964,369.828Z",
    transform: "translate(2205.886 -362.933)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(2.141 8.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M-2246.471,388.888a2.377,2.377,0,0,0,2.378,2.377,2.377,2.377,0,0,0,2.378-2.377,2.379,2.379,0,0,0-2.378-2.379A2.379,2.379,0,0,0-2246.471,388.888Z",
    transform: "translate(2246.471 -386.509)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M-2245.88,369.27a.914.914,0,0,1-.6-.226l-6.127-5.33a.92.92,0,0,1-.091-1.3.92.92,0,0,1,1.3-.09l6.128,5.33a.92.92,0,0,1,.09,1.3A.917.917,0,0,1-2245.88,369.27Z",
    transform: "translate(2252.928 -362.098)",
    fill: "url(#radial-gradient-5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.6a9cdffea00ceb57174fca6419218caf.svg";
export { ForwardRef as ReactComponent };